import { render, staticRenderFns } from "./customtable.vue?vue&type=template&id=e1cea784&scoped=true&"
import script from "./customtable.vue?vue&type=script&lang=js&"
export * from "./customtable.vue?vue&type=script&lang=js&"
import style0 from "./customtable.vue?vue&type=style&index=0&id=e1cea784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cea784",
  null
  
)

export default component.exports